// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalSubscriptionRequestListController = function ($scope, ExternalSubscriptionRequestLog, PUtill, DatepickerUtils) {
    $scope.wasSearching = false;
    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.updateFilter = function () {
        $scope.requestLogs = $scope.paginator(function (options, callback) {
            return ExternalSubscriptionRequestLog.query(options, function () { callback(); $scope.wasSearching = options.search; });
        }, getSearchParams(), 20);
    };

    $scope.statusName = PUtill.getText('Status');
    $scope.externalSubscriptionTypeName = PUtill.getText('Product');

    $scope.statusClass = function (status) {
        switch (status) {
            case 'Succeeded':
                return "label-success";
            case 'Failed':
                return "label-important";
            default:
                return '';
        }
    };

    var getSearchParams = function () {
        if ($scope.dateRange.dateTo)
            $scope.dateRange.dateTo.setDate($scope.dateRange.dateTo.getDate() + 1);
        
        let searchParams = {
            receiptId: $scope.search,
            dateFrom: $scope.dateRange.dateFrom,
            dateTo: $scope.dateRange.dateTo
        };

        if ($scope.status)
            searchParams.status = $scope.status;

        if ($scope.externalSubscriptionTypeName)
            searchParams.type = $scope.externalSubscriptionTypeName;

        return searchParams;
    };

    $scope.setStatus = function (status, defaultLabelName) {
        $scope.status = status.replace(' ', '');
        $scope.statusName = PUtill.getText(defaultLabelName || status);
        $scope.updateFilter();
    };

    $scope.setExternalSubscriptionType = function (externalSubscriptionType, defaultLabelName) {
        $scope.externalSubscriptionType = externalSubscriptionType.replace(' ', '');
        $scope.externalSubscriptionTypeName = PUtill.getText(defaultLabelName || externalSubscriptionType);
        $scope.updateFilter();
    };

    $scope.filter = "";
    $scope.search = "";
    $scope.updateFilter();
};
ExternalSubscriptionRequestListController.$inject = ['$scope', 'ExternalSubscriptionRequestLog', 'PUtill', 'DatepickerUtils'];
